import React__default, { useState } from 'react';
import clsx from 'clsx';
import { IconGridDots } from '@tabler/icons';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import { NavLink } from './NavLink.component.js';
import { SubMenu } from './SubMenu.component.js';
import { getLinkClassName } from './utils/getLinkClassName.js';
import { propTypes, defaultProps } from './LeftNavAppMenu.types.js';
import styles from './LeftNavAppMenu.module.scss.js';

/**
 * The application left nav slide out menu
 *
 * This component renders the navigation as a visible hover to open menu on
 * desktop, and as an off-canvas menu on mobile.
 */
var LeftNavAppMenu = function (props) {
    var onSelectLink = props.onSelectLink, isOpen = props.isOpen, onClose = props.onClose, applicationName = props.applicationName, applicationLinks = props.applicationLinks, className = props.className, withHeader = props.withHeader, onOpenVerticalsMenu = props.onOpenVerticalsMenu, applicationButtonName = props.applicationButtonName;
    var _a = useState(null), selectedNavId = _a[0], setSelectedNavId = _a[1];
    // normally this would be done using :hover,
    // but the state variable is needed for the Play function to work
    // https://github.com/SpotOnInc/style-guide-web/pull/1132/
    var _b = useState(false), hasHover = _b[0], setHasHover = _b[1];
    var handleSelectLink = function (link) {
        if (selectedNavId === link.id) {
            setSelectedNavId(null);
        }
        else {
            setSelectedNavId(link.id);
        }
        onSelectLink(link);
    };
    // needed for the Play function to work
    // https://github.com/SpotOnInc/style-guide-web/pull/1132/
    var setHover = function () {
        setHasHover(true);
    };
    var setUnHover = function () {
        setHasHover(false);
    };
    var leftNavMenuClass = clsx(className, styles.LeftNavMenu, isOpen && styles.LeftNavMenu___offcanvas, withHeader && styles.LeftNavMenu___withHeader, hasHover && styles.LeftNavMenu_hover);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { onClick: onClose, className: clsx(isOpen && styles.Overlay) }),
        React__default.createElement("div", { className: leftNavMenuClass, onMouseEnter: setHover, onMouseLeave: setUnHover, "data-testid": props['data-testid'] },
            React__default.createElement("div", { className: styles.LeftNavMenu_header },
                React__default.createElement("div", { className: styles.HeaderContents },
                    React__default.createElement(ButtonBase, { className: styles.HeaderContents_icon, type: "button", onClick: onOpenVerticalsMenu, title: "AppsIcon", name: applicationButtonName || applicationName },
                        React__default.createElement(IconGridDots, { size: 22 })),
                    React__default.createElement("span", { className: styles.HeaderContents_text }, applicationName))),
            React__default.createElement("nav", { className: styles.LeftNavMenu_container },
                React__default.createElement("ul", { className: styles.VerticalNav }, applicationLinks.map(function (link) { return (React__default.createElement("li", { key: link.id, className: styles.VerticalNav_link },
                    React__default.createElement("div", { className: getLinkClassName(link, 'LinkWrapper') },
                        React__default.createElement(NavLink, { link: link, handleSelectLink: handleSelectLink, selectedNavId: selectedNavId }),
                        React__default.createElement(SubMenu, { handleSelectLink: handleSelectLink, link: link, selectedNavId: selectedNavId })))); }))))));
};
LeftNavAppMenu.propTypes = propTypes;
LeftNavAppMenu.defaultProps = defaultProps;
LeftNavAppMenu.displayName = 'LeftNavAppMenu';

export { LeftNavAppMenu, LeftNavAppMenu as default };
